import { Link } from "react-router-dom";
import { useAddress } from "../../Context/Account";
import { ethers } from "ethers";
import MarketplaceJSON from "../../Promolider.json";
import { useEffect, useState } from "react";
import "../../NFTTile.css";
    
function ProfileCard({data,toolTip,setLoading}) {

    const {address}=useAddress()
    const [priceSell,setPrice]=useState(0)
    const [listedPrice,setListedPrice]=useState(null)
    const [wallet,setWallet]=useState("")
    
    const route=data?.tokenId

    async function unsell(tokenId) {

        setLoading(true)
        try {
             const provider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_PROVIDER_URL);
             const signer = provider.getSigner();

             const contract = new ethers.Contract(MarketplaceJSON.address, MarketplaceJSON.abi, signer);
             const transaction=await contract.unSellToken(tokenId)

             await transaction.wait();
            
            toolTip("You successfully updated the NFT!", true)
            setLoading(false)
        } catch (error) {
            toolTip("Error to listed the NFT!")
            setLoading(false)
        }
    
    }

    async function sellNFT(tokenId,price) {
        if (priceSell<0.01) return setPrice(0)
        setLoading(true)
        try {
             const provider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_PROVIDER_URL)(window.ethereum);
             const signer = provider.getSigner();

             const contract = new ethers.Contract(MarketplaceJSON.address, MarketplaceJSON.abi, signer);

             const listPrice=await contract.getListPrice()

             const salePrice = ethers.utils.parseUnits(price.toString(), 'ether')

             const transaction = await contract.resellToken(tokenId,salePrice,{value:listPrice});
 
             await transaction.wait();
            
            toolTip("You successfully Listed the NFT!", true)
            setLoading(false)
        } catch (error) {
            toolTip("Error to listed the NFT!")
            setLoading(false)
        }
    
    }

  async function checkTransactionStatus(transactionHash) {
    const success = {};
    const provider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_PROVIDER_URL)(window.ethereum);
    const txReceipt = await provider.waitForTransaction(transactionHash);
    if (txReceipt && txReceipt.confirmations) {
      success.ok = true;
      return success;
    } else {
      success.ok = false;
      return success;
    }
  }

  const transferNftWallet = async () => {
    const tokenId = data.tokenId;
    if (!wallet) return;
    setLoading(true);
    try {
      const provider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_PROVIDER_URL)(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        MarketplaceJSON.address,
        MarketplaceJSON.abi,
        signer
      );
      const transaction = await contract.transferToken(wallet, tokenId);
      const success = await checkTransactionStatus(transaction.hash);
      if (!success.ok) throw new Error("Algo no fue bien");
      toolTip("Succesfully Nft has been transfered", true);
      setLoading(false);
      setTimeout(() => window.location.reload(), 2200);
    } catch {
      toolTip("Error Nft hasnt been transfered");
      setLoading(false);
    }
  };

  useEffect(() => {
    async function getListPrice() {
      const provider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_PROVIDER_URL)(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        MarketplaceJSON.address,
        MarketplaceJSON.abi,
        signer
      );
      const listPrice = await contract.getListPrice();
      const salePrice = ethers.utils.formatUnits(listPrice.toString(), "ether");
      setListedPrice(salePrice);
    }
    getListPrice();
  }, []);


  return (
    <div className="card">
      <img src={data.image} className="card-img " alt="" />
      <div className="info">
        <div className="flex justify-between items-center mb-2">
          <p className="text-gray-400">@Promolider</p>
          <p className="text-gray-400">ETHEREUM</p>
        </div>
        <div className="flex justify-between items-center mb-4">
          <h5 className="font-bold">{data.name}</h5>
          <h5 className="font-bold">{data.price} ETH</h5>
        </div>
      </div>
      {data.owner === address && (
        <div className="actions">

          {!data.listed?
          <>
          <button
            className="border-b-2 px-4 py-2 rounded-xl"
            onClick={() => sellNFT(data.tokenId, priceSell)}
          >
            Put on sale
          </button>

          <div className="flex flex-col gap-2">
            <label htmlFor="price" className="text-gray-400">
              Precio:
            </label>
            <input
              type="number"
              id="price"
              placeholder="0.01 Eth"
              className="bg-gray-700 text-white rounded-lg p-2"
              min={0.01}
              onChange={(e) => setPrice(e.target.value)}
            />
            {priceSell === 0 && (
              <span className="text-red-500">
                Debes poner un precio primero
              </span>
            )}
            {listedPrice && priceSell > 0 && (
              <div>
                <span className="text-gray-400">
                  La comisión de venta para Promolider será de:
                </span>
                <br />
                <span className="text-gray-400">
                  {priceSell * listedPrice} ETH
                </span>
              </div>
            )}
          </div>
          </>:
          <button onClick={()=>unsell(data.tokenId)}>Quitar del Marketplace</button>
          }

          <div className="flex flex-col gap-2">
            <label htmlFor="wallet" className="text-gray-400">
              Ingrese la wallet a transferir:
            </label>
            <input
              type="text"
              id="walletAdress"
              placeholder="Escribe la dirección de la wallet..."
              className="bg-gray-700 text-white rounded-lg p-2"
              value={wallet}
              onChange={(e) => setWallet(e.target.value)}
            />
            <button
              className="border-b-2 px-4 py-2 rounded-xl"
              onClick={transferNftWallet}
            >
              Transferir a otra Wallet
            </button>
          </div>

      <Link
        to={`${route ? `/nftPage/${route}` : "/marketplace"}`}
        className="bid size2"
      >
        {route ? "Visualizar NFT" : "Explora Mas"}
      </Link>
      </div>)}
    </div>
  );
}

export default ProfileCard;
